<script>
import { mapGetters } from "vuex";
import appConfig from "@/app.config";

import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";

import KYC from "./VerifyBox.vue";
import AUTH from "./AuthBox.vue";
import ChangePassword from "./ChangeBox.vue";
import BankBox from "./BankBox.vue";
import InfoInvestment from "./InfoInvestment.vue";

export default {
  page: {
    title: "Thông Tin Cá Nhân",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    KYC,
    AUTH,
    ChangePassword,
    BankBox,
    InfoInvestment
  },
  data() {
    return {
      title: "Thông Tin Cá Nhân",
      items: [
        {
          text: "Hệ Thống",
          href: "/"
        },
        {
          text: "Thông Tin Cá Nhân",
          active: true
        }
      ],
      info_kyc: {
        "-1": {
          text: "Tài khoản chưa được xác thực",
          class: "danger"
        },
        0: {
          text: "Tài khoản đang chờ xác thực",
          class: "warning"
        },
        1: {
          text: "Tài khoản đã được xác thực",
          class: "success"
        }
      },
      info_auth: {
        0: {
          img: "e-2fa",
          text: "Chưa bật bảo mật 2 lớp",
          class: "warning"
        },
        1: {
          img: "s-2fa",
          text: "Đã bật bảo mật 2 lớp",
          class: "success"
        }
      },
      tabActive: "KYC"
    };
  },
  mounted() {
    const { type } = this.$route.query;
    if (type) {
      this.tabActive = type == 4 ? "BANK" : "MILE";
    }
  },
  computed: {
    ...mapGetters({
      UserInfo: "user/UserInfo",
      UserKYC: "user/UserKYC",
      UserAuth: "user/UserAuth"
    })
  },
  created() {
    this.$store.dispatch("user/req_getKYC");
    this.$store.dispatch("user/req_getAuth");
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="box-profile">
      <div class="card card-1">
        <div class="card-body">
          <div>
            <div class="mb-4 me-3">
              <i class="mdi mdi-account-circle text-primary h1"></i>
            </div>

            <div>
              <h3>{{ UserInfo.name }}</h3>
              <p class="text-muted mb-1">
                Email:
                <span class="text-white font-size-18 ms-1">{{
                  UserInfo.email
                }}</span>
              </p>
              <p class="text-muted mb-1">
                Tên Đăng Nhập:
                <span class="text-white font-size-18 ms-1">{{
                  UserInfo.userName
                }}</span>
              </p>
              <p class="text-muted mb-0">
                Mã Định Danh:
                <span class="text-white font-size-18 ms-1">{{
                  UserInfo.id
                }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="card-body border-top">
          <div class="account-info">
            <div class="kyc-status" :class="info_kyc[UserKYC.status].class">
              <img src="~@/assets/images/icon.png" alt="" />
              <span>
                {{ info_kyc[UserKYC.status].text }}
              </span>
            </div>
            <div
              class="auth-status"
              :class="info_auth[UserAuth.enable ? 1 : 0].class"
            >
              <img
                :src="
                  require(`@/assets/images/profile/${
                    info_auth[UserAuth.enable ? 1 : 0].img
                  }.png`)
                "
                alt=""
              />
              <span>
                {{ info_auth[UserAuth.enable ? 1 : 0].text }}
              </span>
            </div>
          </div>
        </div>

        <div class="card-footer bg-transparent border-top">
          <div class="box-button">
            <b-button
              @click="tabActive = 'PASS'"
              variant="primary"
              class="my-1 mx-1 d-flex align-items-center justify-content-start"
            >
              <img
                src="~@/assets/images/profile/shield-lock.png"
                height="25"
                alt=""
                class="me-2"
              />
              Đổi Mật Khẩu
            </b-button>
            <b-button
              @click="tabActive = 'G2A'"
              variant="primary"
              class="my-1 mx-1 d-flex align-items-center justify-content-start"
            >
              <img
                src="~@/assets/images/profile/w-2fa.png"
                height="25"
                alt=""
                class="me-2"
              />
              Bảo Mật 2 Lớp
            </b-button>
            <b-button
              @click="tabActive = 'KYC'"
              variant="primary my-1 mx-1 d-flex align-items-center justify-content-start"
            >
              <img
                src="~@/assets/images/profile/w-2fa.png"
                height="25"
                alt=""
                class="me-2"
              />
              Xác Thực Tài Khoản
            </b-button>
            <b-button
              @click="tabActive = 'BANK'"
              variant="primary"
              class="my-1 mx-1 d-flex align-items-center justify-content-start"
            >
              <img
                src="~@/assets/images/profile/shield-lock.png"
                height="25"
                alt=""
                class="me-2"
              />
              Cập Nhật Tài Khoản Ngân Hàng
            </b-button>
            <b-button
              @click="tabActive = 'InfoInvestment'"
              variant="primary"
              class="my-1 mx-1 d-flex align-items-center justify-content-start"
            >
              <img
                src="~@/assets/images/profile/shield-lock.png"
                height="25"
                alt=""
                class="me-2"
              />
              Thông Tin Cá Nhân
            </b-button>
          </div>
        </div>
      </div>
      <div class="card card-2">
        <change-password v-if="tabActive == 'PASS'" />
        <AUTH v-if="tabActive == 'G2A'" />
        <KYC v-if="tabActive == 'KYC'" />
        <BankBox v-if="tabActive == 'BANK'" />
        <InfoInvestment v-if="tabActive == 'InfoInvestment'" />
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
.box-profile {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  max-width: 1440px;
  margin: 0 auto 40px;
  .card-1 {
    flex: 0 0 40%;
    min-width: 250px;
    max-width: 405px;
    margin: 0 15px;
  }
  .card-2 {
    flex: 1 1 auto;
    margin: 0 15px;
  }
  @media (max-width: 1199px) {
    flex-direction: column;
    .card-1,
    .card-2 {
      width: 100%;
      flex: unset;
      margin: 15px auto;
    }
  }
}
.account-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .auth-status,
  .kyc-status {
    width: max-content;
    min-width: calc(50% - 1.5rem);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 5px 10px;
    border-radius: 10px;
    margin: 5px;
    @media (min-width: 1200px) {
      width: 100%;
    }
    &.danger {
      border: 1px solid red;
      span {
        color: red;
      }
    }
    &.warning {
      border: 1px solid #f1dc22;
      span {
        color: #f1dc22;
      }
    }
    &.success {
      border: 1px solid rgb(25, 231, 25);
      span {
        color: rgb(25, 231, 25);
      }
    }
    img {
      height: 40px;
      margin-right: 5px;
    }
    span {
      color: #fff;
      font-weight: 500;
      font-size: 16px;
      padding-left: 15px;
    }
  }
}
.box-button {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  button {
    width: max-content;
    min-width: calc(50% - 0.5rem);
    @media (min-width: 1200px) {
      width: 100%;
    }
  }
}
</style>
